function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  max-width: 100%;\n  margin-top: 0.75rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: grid;\n  gap: 2px;\n  width: 100%;\n  max-height: 500px;\n  border-radius: 16px;\n  overflow: hidden;\n  aspect-ratio: 1 / 1;\n  background-color: var(--media-preview-grid-bg, transparent);\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  width: 100%;\n  height: 100%;\n  border-radius: 16px;\n  overflow: hidden;\n  cursor: pointer;\n  background-color: ",
        ";\n  transition: transform 0.3s ease, opacity 0.3s ease, box-shadow 0.3s ease;\n  transform: ",
        ";\n  opacity: ",
        ";\n  box-shadow: ",
        ";\n\n  ",
        "\n  ",
        "\n\n  img,\n  video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 20;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 9999px;\n  background-color: rgba(0, 0, 0, 0.68);\n  color: #fff;\n  cursor: pointer;\n  opacity: ",
        ";\n  transform: ",
        ";\n  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.82);\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  z-index: 15;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 8px;\n  border-radius: 6px;\n  background-color: rgba(0, 0, 0, 0.58);\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  text-transform: uppercase;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: 12;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(3px);\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: 700;\n\n  span {\n    transform: translateY(1px);\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.55) 0%,\n    rgba(0, 0, 0, 0.05) 65%\n  );\n  pointer-events: none;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 5;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border: none;\n  border-radius: 9999px;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  cursor: pointer;\n  transform: translate(-50%, -50%) scale(",
        ");\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  opacity: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  z-index: 6;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 9999px;\n  background-color: rgba(0, 0, 0, 0.45);\n  color: #fff;\n  cursor: pointer;\n  opacity: ",
        ";\n  transform: ",
        ";\n  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.7);\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  right: 12px;\n  bottom: 12px;\n  z-index: 6;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 8px;\n  border-radius: 6px;\n  background-color: rgba(0, 0, 0, 0.65);\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
var applyGridTemplate = function(layoutClass) {
    if (layoutClass.includes('grid-3-items')) {
        return '\n      grid-template-areas:\n        "a a b"\n        "a a c";\n      grid-template-columns: 1fr 1fr 1fr;\n      grid-template-rows: 1fr 1fr;\n    ';
    }
    if (layoutClass.includes('grid-cols-1')) {
        return 'grid-template-columns: 1fr;';
    }
    if (layoutClass.includes('grid-cols-2')) {
        return 'grid-template-columns: 1fr 1fr;';
    }
    return '';
};
var applyGridArea = function(itemClass) {
    if (itemClass.includes('grid-area-a')) {
        return 'grid-area: a;';
    }
    if (itemClass.includes('grid-area-b')) {
        return 'grid-area: b;';
    }
    if (itemClass.includes('grid-area-c')) {
        return 'grid-area: c;';
    }
    return '';
};
export var Container = styled.div(_templateObject());
export var MediaGrid = styled.div(_templateObject1(), function(param) {
    var layoutClass = param.layoutClass;
    return applyGridTemplate(layoutClass);
});
export var MediaItem = styled.div(_templateObject2(), function(param) {
    var isVideo = param.isVideo;
    return isVideo ? 'rgba(0, 0, 0, 0.92)' : 'transparent';
}, function(param) {
    var isHovered = param.isHovered;
    return isHovered ? 'scale(0.99)' : 'scale(1)';
}, function(param) {
    var isHovered = param.isHovered;
    return isHovered ? 0.95 : 1;
}, function(param) {
    var isHovered = param.isHovered;
    return isHovered ? '0 12px 32px rgba(15, 23, 42, 0.18)' : 'none';
}, function(param) {
    var itemClass = param.itemClass;
    return applyGridArea(itemClass);
}, function(param) {
    var itemClass = param.itemClass;
    return itemClass.includes('aspect-square') ? 'aspect-ratio: 1 / 1;' : '';
});
export var RemoveButton = styled.button(_templateObject3(), function(param) {
    var isHovered = param.isHovered;
    return isHovered ? 1 : 0;
}, function(param) {
    var isHovered = param.isHovered;
    return isHovered ? 'scale(1.08)' : 'scale(1)';
});
export var ShortFormBadge = styled.div(_templateObject4());
export var OverflowIndicator = styled.div(_templateObject5());
export var VideoGradientOverlay = styled.div(_templateObject6());
export var VideoPlayButton = styled.button(_templateObject7(), function(param) {
    var isHovered = param.isHovered;
    return isHovered ? 1.08 : 1;
}, function(param) {
    var isHovered = param.isHovered;
    return isHovered ? 1 : 0.7;
});
export var FullscreenToggle = styled.button(_templateObject8(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? 1 : 0;
}, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? 'translateY(0)' : 'translateY(-6px)';
});
export var DurationBadge = styled.div(_templateObject9());
